import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import {
    // useLocation, 
    useNavigate
} from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const Login = () => {

    let navigate = useNavigate();
    // let location = useLocation();
    let userFrom =
        // location.state?.from?.pathname || 
        "/previous-uploaded-list";
    let adminFrom = "/";

    const { user, setUser } = useAuth();

    // user.role === 1 ? let from ="/" : let from ="/previous-uploaded-list"

    if(user?.code) {
        if(user.role === 1) {
            navigate(adminFrom, { replace: true })
        }
        else {
            navigate(userFrom, { replace: true })
        }
    }

    // user?.code && navigate(from, { replace: true })

    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = data => processLogin(data);
    const [loginError, setLoginError] = useState('');

    const processLogin = (details) => {

        document.getElementById('action').style.display = 'none'
        document.getElementById('processing').style.display = 'block'

        fetch('https://vendor-managed-inventory-transparency.onrender.com/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(details)
        })
            .then(res => res.json())
            .then(result => {
                if (result.status === false) {
                    setLoginError(result.message)
                    document.getElementById('action').style.display = 'block'
                    document.getElementById('processing').style.display = 'none'
                }
                else {
                    setUser(result.user)
                    setLoginError('')
                    localStorage.setItem('uId', result.user._id)
                }
            })
    }

    return (
        <div className='bg-brand d-flex justify-content-center align-items-center'>

            <div className="bg-white-container">
                <h1 className='fs-4 text-center fw-bold mt-5 px-3'>Vendor Manage Inventory Stock and Transparency</h1>
                <h2 className='fs-4 text-center text-brand fw-bold mt-3'>Sign in to Account</h2>

                <div className="mt-5 px-5 pt-5">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group mb-3">
                            <input placeholder='Enter outlet email' className='form-control' type='text' {...register("code", { required: true })} />
                            {errors.code && <span className='text-danger fw-bold'>Email required</span>}
                        </div>

                        <div className="form-group mb-3">
                            <input placeholder='Enter outlet password' className='form-control' type='password' {...register("password", { required: true })} />
                            {errors.password && <span className='text-danger fw-bold p-1'>Password required</span>}
                        </div>

                        <p className='text-danger fw-bold'>{loginError}</p>

                        <input id='action' type="submit" className='btn-action w-100 text-center' value='Sign in' />
                    </form>

                    <button style={{ display: 'none' }} id='processing' className='btn-action w-100' disabled><div style={{ height: '15px', width: '15px' }} className="spinner-border me-1"></div>Processing . . .</button>
                </div>

                {/* <p className='float-end pe-5 mt-3 text-brand'>Forgot Password?</p> */}

            </div>
        </div>
    );
};

export default Login;